const API = {
   BASE_URL:"https://premiumblogapi.onrender.com",
  //BASE_URL:"http://localhost:7500",
   }
 
 export default API;